import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { SendDeviceCommandDocument } from './send-command.generated';

export const useSendDeviceCommand = (
  options: ApiOptions<typeof SendDeviceCommandDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(SendDeviceCommandDocument, {
    ...useNotifications(SendDeviceCommandDocument, {
      failure: t('api.common.error_generic'),
      success: ({ sendDeviceCommand }) => {
        if (!sendDeviceCommand?.devices) return t('api.devices.send_command_error_no_devices');

        const count = sendDeviceCommand.devices.length;
        const errors = sendDeviceCommand.error;

        return errors
          ? t('api.devices.send_command_error', { errors })
          : t('api.devices.send_command_success_plural', { count });
      },
    }),
    ...options,
  });
};
